module.exports = __webpack_public_path__ + "static/img/user-bg.f89af9b3.png";